import React from 'react'
import Svg from './Svg'
export const SvgCheck = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M19.288 3.221L24 7.284 9.511 21.968l-.051-.044-.043.044L0 13.837l4.339-4.413 4.766 4.117z" />
  </Svg>
))
SvgCheck.isIcon = true
export default SvgCheck
